/* eslint-disable keyword-spacing */
/* eslint-disable space-infix-ops */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import AutoComplete from './components/auto-complete';
import BaseModal from '../../components/modal/BaseModal';
import Progress from '../../components/progress';
import Button from '../../components/button/Button';
import Tab from './components/tab/index';
import Tag from '../../components/tag';
import {
  CaptureOrRecord,
  Files,
  Remark,
  GeoInfo
} from './Modules';
import Debug from './debug';
import RadarChart from './components/radar-chart';

// 深色模式图标
import startBg from '../../assets/imgs/debug-start-transparent.png';
import loadBg from '../../assets/imgs/debug-load-transparent.png';
import iconCarEmpty from '../../assets/imgs/icon-car-empty.png';
import iconCarOccupy from '../../assets/imgs/icon-car-occupy.png';
// 浅色模式图标
import startBgLight from '../../assets/imgs/debug-start-transparent-light.png';
import loadBgLight from '../../assets/imgs/debug-load-transparent-light.png';

import play from '../../assets/imgs/play.png';

import Toast from '../../components/toast/Toast';
import Message from '../../components/message';
import { formatDateTime, quit, countEventTrigger } from '../../js/utils';
import {
  getOSS,
  submitParkingspaceData,
  updateProjectList,
  submitParkingspaceDataForce,
  postCallAction,
  sendResult,
  getSerial,
  getNightMode,
  saveDebugLog,
  setNightMode
} from '../../service';
import nativeInterface from '../../native-interact/native';
import LogDetail from './LogDetail';
import { logStore } from '../../js/Log';
import { takeOffStore } from '../../mobx/stores/takeoff';
import RFBluetoothInstance, { cmdLogManager } from '../../native-interact/RFBluetooth';
import Icon from '../../components/icon/Icon';
import { log } from '../../native-interact/EventEmmiter';
import { setWorkState, setDelayWork, submitSaveConf } from '../../service/command';
// import { WORK_MODE } from '../../mobx/stores/work-mode';
import { readStore } from '../../mobx/stores/rf';
import { upgradeStore } from '../../mobx/stores/upgrade';
import UpgradeFrank from './UpgradeFrank';
import Keyboard from './components/keyboard';
import { stepTime } from '../../mobx/stores/steptime';
import AudioInput from './components/audio-input';
import Video from './components/video-play';
import Login from '../../components/login/Login'; // 测试登录接口页面跳转
import { selectGeoReplace } from './components/repair-serial/data';
import RepairSerial from './components/repair-serial/index'; // 地磁更换弹窗维修

class DebugAuto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // bg: '',
      parkData: [],
      showLog: false,
      showRadarBase: false,
      debugState: 0, // 0: 未安装 1: 安装成功 2：安装中断 3：安装失败
      tabData: [
        {
          icon: '',
          name: '拍照/录音',
          contentComponent: CaptureOrRecord
        },
        {
          icon: 'wenjianjia',
          name: '文件',
          store: this.props.parkStore,
          contentComponent: Files
        },
        {
          icon: 'remark',
          name: '备注',
          store: this.props.parkStore,
          contentComponent: Remark
        },
        {
          icon: 'gengduo',
          name: '更多',
          store: this.props.parkStore,
          readStore: this.props.readStore,
          globalStore: this.props.globalStore,
          contentComponent: GeoInfo
        }
      ],
      showUpgrade: false, // 显示升级地磁弹窗
      upGradeType: '', // 升级类型
      shwoKeyboard: false,
      // parkNo: '',
      showAudio: false, // 显示语音输入框
      showVideo: false, // 显示教学视频
      showRepair: false, // 显示维修表单
      isfieldRepair: false, // 是否已提交维修更换信息
      oldSerial: '' // 原绑定地磁号
    };

    // 用于根据mac获取到车位信息时更新停车场信息
    this.parkRef = React.createRef();

    // 定义车位号输入框的对象值
    this.parkNoRef = React.createRef();

    this.gotoOld = countEventTrigger(this.gotoOld).bind(this);
  }

  componentDidMount() {
    this.addCmdLogProcess();
    // 先更新项目列表再上传车位数据
    updateProjectList();
    this.props.parkStore.getPark().then((data) => {
      this.setState({
        parkData: data.records
      });
      setTimeout(() => {
        this.parkRef.current.onSelect(this.props.parkStore.form, true);
      }, 0);
    }).catch(() => {});
  }

  componentWillUnmount() {
    cmdLogManager.delete(this.cmdLogProcess);
  }

  onParkChange(data) {
    this.props.parkStore.form.parkinglotid = data.id;
    this.props.parkStore.form.parkinglotname = data.name;
  }

  // 监听车位号变化
  onPSChange(e) {
    const value = e.target.value;
    localStorage.setItem('parkingno', value);
    this.props.parkStore.form.parkingno = value;
  }

  // 车位号自动+1
  // eslint-disable-next-line react/sort-comp
  addParkingno(carno) {
    // 得出车位号中最后纯数字字段
    if (!carno) {
      return '';
    }
    const carnoArray = carno.split('');
    const carnoLength = carnoArray.length;
    let first = '';
    let end = [];
    for (let i = carnoLength - 1; i >= 0; i--) {
      if (parseFloat(carnoArray[i]).toString() !== 'NaN') {
        end.push(carnoArray[i]);
      } else {
        first = carno.substring(0, i + 1);
        break;
      }
    }
    end = end.reverse().join('');
    // 纯数字字段+1
    const numLength = end.length;
    let newNo = Number(end) + 1;
    // 数字位数之前要补0的个数
    if (numLength - newNo.toString().length > 0) {
      newNo = '0'.repeat(numLength - newNo.toString().length) + String(newNo);
    }

    return first + newNo;
  }

  // 显示自定义软键盘
  // eslint-disable-next-line react/sort-comp
  showKeyboard = () => {
    this.setState({
      shwoKeyboard: true
    });
  }

  // 隐藏自定义软键盘
  hideKeyboadr = () => {
    this.setState({
      shwoKeyboard: false
    });
  }

  // 输入自定义软键盘输入车位号
  inputParkno = (e) => {
    this.props.parkStore.form.parkingno = e;
    // console.log(this.props.parkStore.form.parkingno)
    this.parkNoRef.current.value = e;
    // this.setState({
    //   parkNo: e
    // });
  }

  // 显示语音输入框
  showAudio = () => {
    this.setState({
      showAudio: true
    });
  }

  // 隐藏语音输入框
  hideAudio = () => {
    this.setState({
      showAudio: false
    });
  }

  // 显示教学视频
  showVideo = () => {
    this.setState({
      showVideo: true
    });
  }

  // 隐藏教学视频
  hideVideo = () => {
    this.setState({
      showVideo: false
    });
  }

  submitInfo = async (parkStore) => {
    // 新旧地磁更换拦截请求 未填写过维修更换信息
    const { nightModeInfo, RFID } = readStore;
    const { form: { parkingno, parkinglotid } } = parkStore;
    if (!parkinglotid) {
      Toast.fail('请选择停车场');
      return;
    }
    if (!parkingno) {
      Toast.fail('请输入车位号');
      return;
    }
    if(!this.state.isfieldRepair) {
      const replaceResult = await selectGeoReplace({
        projectId: nightModeInfo.projectId,
        serial: RFID,
        parkingno,
        parkinglotid
      });
      console.log('车位地磁更换信息查询', replaceResult);
      if (replaceResult.errno == '406') {
        Message.confirm(`检测到车位${parkingno}已绑定地磁${replaceResult.data}，是否取消原绑定关系？`, () => {
          this.setState({
            showRepair: true,
            oldSerial: replaceResult.data
          });
        });
        return;
      }
    }

    this.submitting = true; // 是否正在提交中，避免重复提交
    console.log('夜间模式配置信息：', nightModeInfo);
    this.validate().then((data) => {
      let form = data;
      if (parkStore.nowStart) {
        form = Object.assign(data, { abletime: formatDateTime(+Date.now(), 'date') });
      }

      // 原生向阿里云上传图片和录音
      getOSS().then((res) => {
        const callResult = nativeInterface.uploadResource(res);
        postCallAction(`调用原生接口上传图片，原生接口${callResult instanceof Error ? '不存在' : '调用成功'}`);
      });

      const loading = Toast.loading();
      let rqData = {};

      try {
        rqData = Object.assign({}, form, {
          photourl: parkStore.photos.map(item => item.path.replace(/.*\/(.*)?$/, '$1')).join(','),
          voiceurl: parkStore.audios.map(item => item.path.replace(/.*\/(.*)?$/, '$1')).join(','),
          state: this.state.debugState,
          error_info: this.state.debugState === 3 ? (logStore.logs[logStore.logs.length - 1] && logStore.logs[logStore.logs.length - 1].log_content) : '',
          radar: toJS(this.props.geoStore.radarBase).join(',')
        });
      } catch (error) {
        console.log(error);
      }

      // console.log(rqData);
      // this.submitting = false;
      // loading.destroy();
      // return;

      this.saveConfig().then(() => {
        // 上传车位信息
        submitParkingspaceData(rqData).then(() => {
          this.submitting = false;

          // // 设置项目夜间模式位置
          // const status = rqData.nightModel == '1' ? 1 : 0; // 设置的夜间模式 1 启用 2 禁用
          // const { nightModeInfo, RFID } = readStore; // 地磁项目夜间模式信息
          const nightStatus = parseInt(nightModeInfo.status, 10);
          if(nightStatus === 1 || nightStatus === 0) {
            setNightMode({
              serial: RFID,
              projectId: nightModeInfo.projectId, // 项目id
              commandType: 1, // 命令类型 1：夜间休眠
              commandParam: {
                startTime: nightModeInfo.startTime, // 开始时间
                endTime: nightModeInfo.endTime // 结束时间
              }, // 命令参数
              status: nightStatus // 命令状态0：禁用 1：启用
            });
          }

          if (!parkStore.nowStart) {
            localStorage.setItem('geo_abletime', this.props.parkStore.form.abletime);
          }

          localStorage.setItem('geo_park_in_speed', this.props.parkStore.form.parkInSpeed);
          localStorage.setItem('geo_park_out_speed', this.props.parkStore.form.parkOutSpeed);
          // 车位号自增1存入本地缓存中 刷新页面后输入框车位号自动+1
          this.props.parkStore.form.parkingno = this.addParkingno(this.props.parkStore.form.parkingno);
          localStorage.setItem('parkingno', this.props.parkStore.form.parkingno);

          Message.alert('提交成功', () => {
            // FIX 提交后刷新页面蓝牙未关闭则开启新地磁调试导致蓝牙连接的还是旧地磁
            RFBluetoothInstance.closeConnect().catch(() => {
              return Promise.resolve();
            }).then(() => {
              window.location.reload();
            });
          });
        }).catch((error) => {
          this.submitting = false;
          if (error.errno === '501') {
            Message.confirm(`${error.errtext}，是否取消原绑定，继续提交？`, () => {
              this.forceSubmit(rqData);
            });
          }
        });
      }).catch(() => {
        this.submitting = false;
        Toast.fail('启用设置失败，请重试');
      }).then(() => {
        loading.destroy();
      });
    }).catch(() => {
      this.submitting = false;
    });
  }

  onSubmit() {
    if (this.submitting) {
      return;
    }

    const { parkStore } = this.props;

    const t = new Date();
    const currentDay = `${t.getFullYear()}-${t.getMonth() + 1}-${t.getDate()}`;
    // console.log(localStorage.getItem('currentDay'));
    if (parkStore.nowStart && currentDay !== localStorage.getItem('current_day')) {
      // 立即启用 弹窗提示耗电信息
      Message.skipConfirm('当前状态为“立即启用”地磁，即现在起，地磁进入工作状态，持续产生耗电量。若确认选择立即启用地磁后，因现场实际未使用而造成的耗电量，立方不承担相应责任。', () => {
        this.submitInfo(parkStore);
      });
    } else {
      this.submitInfo(parkStore);
    }
  }

  // 设置当前安装调试的进度
  setProcess(name, rate) {
    this.props.globalStore.currentProcess = name;
    this.props.globalStore.processRate = rate;
  }

  saveConfig() {
    const {
      nowStart,
      form
    } = this.props.parkStore;
    const canSetSpeed = this.props.globalStore.canSetDetectSpeed;
    const inSpeed = canSetSpeed ? form.parkInSpeed : null;
    const outSpeed = canSetSpeed ? form.parkOutSpeed : null;
    if (nowStart) {
      // FIXED：立即启用需要修改预约配置，不然已延期启用地磁再次立即启用会失效
      return submitSaveConf({
        start: '2018-01-01 00:00:00',
        end: '2018-01-01',
        inSpeed,
        outSpeed,
        oCommand: ['goto WORK']
      });
    }
    return setDelayWork({
      end: form.abletime,
      inSpeed,
      outSpeed,
    });
  }

  addCmdLogProcess() {
    const that = this;
    this.cmdLogProcess = function (logContent, next) {
      if (logContent.includes('imsemi base:')) {
        const data = logContent.match(/imsemi base:{(.*)}/)[1]
          .trim()
          .split(/\s+/);
        console.log('雷达值：data');
        that.props.geoStore.setRadarBase(data);
      }
      next();
    };
    cmdLogManager.use(this.cmdLogProcess);
  }

  forceSubmit(data) {
    submitParkingspaceDataForce(
      data,
      this.props.parkStore.oldParkingno
    ).then(() => {
      // 车位号自增1存入本地缓存中 刷新页面后输入框车位号自动+1
      this.props.parkStore.form.parkingno = this.addParkingno(this.props.parkStore.form.parkingno);
      localStorage.setItem('parkingno', this.props.parkStore.form.parkingno);
      Message.alert('提交成功', quit);
    }).catch(() => {});
  }

  // 验证提交内容
  validate() {
    const form = this.props.parkStore.form;
    const status = this.props.globalStore.status;
    const current = new Date();
    const currentDate = new Date(current.getFullYear(), current.getMonth(), current.getDate());

    return new Promise((resolve, reject) => {
      let flag = true;
      let msg = '';
      if (!form.parkinglotid) {
        flag = false;
        msg = '请选择停车场';
      } else if (!form.parkingno) {
        flag = false;
        msg = '请输入车位号';
      } else if (!(/^[a-zA-Z0-9]+$/.test(form.parkingno))) {
        flag = false;
        msg = '车位号格式错误（英文字母和数字）';
      } else if (!form.lon || !form.lat) {
        flag = false;
        msg = '请选择定位';
      } else if (!form.serial) {
        flag = false;
        msg = '请先使用读卡器读取设备序列号';
      } else if (!this.props.parkStore.nowStart && new Date(form.abletime.replace(/-/g, '/')) <= currentDate) {
        flag = false;
        msg = '延期启用日期应晚于当天日期';
      } else {
        form.parkingno = form.parkingno.toUpperCase();
      }

      if (flag === false) {
        Toast.fail(msg);
        return reject();
      }

      if (status === 'default') {
        // flag = false;
        // msg = '请先安装地磁';
        this.setState({
          debugState: 0
        });
        Toast.fail('请先安装地磁再提交');
        reject();
      } else if (status === 'loading') {
        this.setState({
          debugState: 2
        });
        // flag = false;
        // msg = '地磁正在安装，请等待安装完成';
        Message.confirm('地磁正在安装中，确定中止安装继续提交？', () => {
          this.debug.stop();
          resolve(form);
        }, () => {
          reject();
        });
      } else if (status === 'error' && flag) {
        this.setState({
          debugState: 3
        });
        Message.confirm('安装失败，是否继续提交？', () => {
          resolve(form);
        }, () => {
          reject();
        });
      } else {
        this.setState({
          debugState: 1
        });
        resolve(form);
      }
    });
  }

  // 安装调试前的过滤及重置
  startDebug() {
    const status = this.props.globalStore.status;

    if (status === 'default') {
      this.debugBegin();
    }
    if (status === 'success' || status === 'error') {
      Message.confirm('是否重新安装？', () => {
        this.reset();
        RFBluetoothInstance.closeConnect().then(() => {
          setTimeout(() => {
            this.debugBegin();
          }, 0);
        }).catch(() => {
          Toast.fail('蓝牙连接断开失败，请重试');
        });
      }, () => {});
    }
  }

  // 开始安装调试
  debugBegin() {
    console.log('开始调试', formatDateTime(new Date(), 'datetime'));
    // stepTime.stepArray = []; // 每次重新点击安装就重置全局数组
    // stepTime.allStartTime = new Date().getTime();

    this.props.globalStore.status = 'loading';
    // const loadBackground = this.props.globalStore.themeType === 'dark' ? loadBg : loadBgLight;
    // this.setState({
    //   bg: loadBackground
    // });

    if (!this.debug) {
      this.debug = new Debug(
        (data, index, total, base, preBase) => {
          if (index === 1) {
            log.post({
              log_content: '开始安装调试',
              raw_content: '开始安装调试'
            }, true);
          }

          if (data.name === '密钥认证') {
            // 车位数据已经获取成功，更新停车场自动补全框默认值
            this.parkRef.current.onSelect(this.props.parkStore.form, true);
          }
          this.setProcess(data.name, total > 0 ? parseInt(index / total * base + preBase, 10) : 0);
        }
      );
    }
    this.debug.start()
      .then(() => {
        log.post({
          log_content: '安装调试成功',
          raw_content: '安装调试成功'
        }, true);
        this.setProcess('安装完成', 100);
        this.props.globalStore.status = 'success';

        const { nightModeInfo: { projectId }, RFID } = readStore;
        const { parkingno } = this.props.parkStore.form;
        console.log('项目id', projectId, '地磁号', RFID);

        saveDebugLog({
          projectId,
          parkingno,
          serial: RFID,
          operateType: 3,
          geoActivateAttachList: [
            {
              type: 1,
              propertyName: '调试状态',
              propertyKey: 'current_state',
              propertyValue: '成功'
            }
          ]
        });

        // console.log('安装调试成功', formatDateTime(new Date(), 'datetime'));
        // stepTime.allEndTime = new Date().getTime();
        // const submitData = stepTime.stepArray.map((item) => {
        //   return {
        //     action: item.action,
        //     createtime: item.createtime,
        //     endtime: item.endtime,
        //     isSuccess: item.isSuccess
        //   };
        // });
        // const debugInfo = Object.assign({}, {
        //   body: submitData,
        //   result: {
        //     starttime: stepTime.allStartTime,
        //     result: 1,
        //     endtime: stepTime.allEndTime,
        //     geomagnetic_serial: this.props.parkStore.form.serial
        //   }
        // });
        // console.log(debugInfo);
        // sendResult(debugInfo);
      })
      .catch((error) => {
        const { message } = error;
        log.post({
          log_content: `安装调试失败 ${error instanceof Error ? `[${message}]` : ''} ${error.advice ? error.advice : '请重新调试'}`,
          raw_content: '安装调试失败'
        }, false);
        this.props.globalStore.currentProcess = '安装失败';
        this.props.globalStore.status = 'error';

        const { nightModeInfo: { projectId }, RFID } = readStore;
        const { parkingno } = this.props.parkStore.form;
        console.log('项目id', projectId, '地磁号', RFID, '错误信息', error);

        saveDebugLog({
          projectId,
          parkingno,
          serial: RFID,
          operateType: 3,
          geoActivateAttachList: [
            {
              type: 1,
              propertyName: '调试状态',
              propertyKey: 'current_state',
              propertyValue: '失败'
            },
            {
              type: 1,
              propertyName: '异常类型',
              propertyKey: 'error_type',
              propertyValue: message || '安装调试失败 脚本执行过程中断'
            }]
        });

        // console.log('安装调试失败', formatDateTime(new Date(), 'datetime'));
        // stepTime.allEndTime = new Date().getTime();
        // const submitData = stepTime.stepArray.map((item) => {
        //   return {
        //     action: item.action,
        //     createtime: item.createtime,
        //     endtime: item.endtime,
        //     isSuccess: item.isSuccess
        //   };
        // });
        // const debugInfo = Object.assign({}, {
        //   body: submitData,
        //   result: {
        //     starttime: stepTime.allStartTime,
        //     result: 0,
        //     endtime: stepTime.allEndTime,
        //     geomagnetic_serial: this.props.parkStore.form.serial
        //   }
        // });
        // console.log(debugInfo);
        // sendResult(debugInfo);

        // 版本号获取超时错误
        if (message === '获取版本号错误') {
          this.props.globalStore.currentProcess = '自动获取版本号错误，请点击重新安装';
          // 写入本地日志
          logStore.logs.push(Object.assign({}, {
            log_time: formatDateTime(new Date()),
            log_content: '自动获取版本号超时'
          }));
        }
        // 服务器版本号获取错误 或 版本号解析比较错误
        if (message === '获取服务器最新版本号错误') {
          this.props.globalStore.currentProcess = '版本号比对超时，请点击重新安装';
          // 写入本地日志
          logStore.logs.push(Object.assign({}, {
            log_time: formatDateTime(new Date()),
            log_content: '版本号比对超时'
          }));
        }
        // 判断安装报错是否是地磁版本升级
        if (message === '正在升级CPU1' || message === '正在升级CPU2') {
          this.props.globalStore.currentProcess = '地磁版本需升级';
          this.setState({
            showUpgrade: true,
            upGradeType: message
          });
        }

        let data = sessionStorage.getItem('install_fail_radar_base');
        if (data) {
          data = JSON.parse(data);
          if (data.mac === readStore.RFID && data.count >= 3) {
            Message.alert('该地磁已经连续多次安装调试失败，建议更换地磁', () => {});
          }
        }
      });
  }

  // 显示日志弹窗
  showLog() {
    // const postData = Object.assign({}, {
    //   log_serial_number: '123456',
    //   log_time: '2022-04-18 15:00:00',
    //   operator_account: 'test',
    //   operator_name: 'test',
    // }, {
    //   mac: '',
    //   log_type: '2',
    //   frank_status: '30'
    // }, {
    //   log_content: '测试错误',
    //   error: '错误原因'
    // });
    // logStore.logs.push(Object.assign({ postState: 'fail' }, postData));
    this.setState({
      showLog: true
    });
  }

  // 隐藏日志弹窗
  hideLog() {
    this.setState({
      showLog: false
    });
  }

  showRadarBase() {
    this.setState({
      showRadarBase: true
    });
  }

  hideRadarBase() {
    this.setState({
      showRadarBase: false
    });
  }

  // 隐藏升级地磁弹窗
  hideUpgrade = () => {
    this.setState({
      showUpgrade: false
    }, () => {
      this.startDebug();
    });
  }

  // 隐藏更换表单弹窗
  hideRepair = () => {
    this.setState({
      showRepair: false,
      isfieldRepair: true
    });
  }

  // 重置界面涉及到的所有store及值
  reset() {
    const {
      parkStore,
      globalStore,
      geoStore,
      // readStore
    } = this.props;

    // this.setState({
    //   bg: startBg
    // });
    parkStore.reset();
    globalStore.reset();
    geoStore.reset();
    readStore.reset();
    logStore.reset();
    takeOffStore.reset();
    this.parkRef.current.onSelect(this.props.parkStore.form, true);
    this.setState({
      isfieldRepair: false
    });
  }

  gotoOld() {
    const search = window.location.search;
    window.location.replace(`./old.html${search ? `${search}&` : '?'}random=${Math.random()}`);
  }

  gotoDetect() {
    const search = window.location.search;
    window.location.replace(`./nbstat.html${search ? `${search}&` : '?'}random=${Math.random()}`);
  }

  render() {
    const { nightModeInfo: { projectId } } = readStore;
    const { parkStore, globalStore } = this.props;
    const {
      status,
      currentProcess,
      processRate,
      themeType
    } = globalStore;
    const startBackground = themeType === 'dark' ? startBg : startBgLight;
    const loadBackground = themeType === 'dark' ? loadBg : loadBgLight;
    const bg = status === 'default' ? startBackground : loadBackground;
    const {
      parkData,
      // bg,
      tabData,
      showLog,
      showRadarBase,
      showUpgrade,
      upGradeType,
      shwoKeyboard,
      showAudio,
      showVideo,
      showRepair,
      oldSerial
    } = this.state;
    const geoBtnDesc = (function () {
      switch (status) {
        case 'default':
          return '开始安装';
        case 'loading':
          return '正在安装';
        case 'success':
          return '安装完成';
        case 'error':
          return '安装错误';
        default:
          return '';
      }
    }());
    return (
      <div>
        <AutoComplete
          placeholder="请选择停车场"
          className="item form-item"
          data={parkData}
          themeType={themeType}
          uniqKey="id"
          valueKey="name"
          style={{ color: themeType === 'dark' ? '#fff' : '#333' }}
          onSelectList={data => this.onParkChange(data)}
          ref={this.parkRef}
        />
        <div className="parkingspace item form-item">
          <div className="parkingspace-left">车位号</div>
          <div className="parkingspace-input">
            <input
              type="text"
              placeholder="请输入车位号"
              className="pure-input parkno-input"
              maxLength="20"
              readOnly
              style={{ color: themeType === 'dark' ? '#fff' : '#333' }}
              ref={this.parkNoRef}
              value={parkStore.form.parkingno}
              onClick={this.showKeyboard}
              onChange={e => this.onPSChange(e)}
            />
          </div>
          <div className="luyin-input" onClick={this.showAudio}>
            <i className="iconfont icon-luyin"></i>
          </div>
          <div className="parkingspace-right">
            <img
              src={globalStore.handsetDetectState === '1' ? iconCarOccupy : iconCarEmpty}
              alt="有车/无车"
              style={{ height: 30 }}
              onClick={() => this.gotoDetect()}
            />
          </div>
        </div>
        <div className="item form-item">
          <Tag
            text={`${globalStore.modeDesc}${globalStore.modeDesc !== '未知' ? '模式' : ''}`}
            onClick={() => this.gotoOld()}
          />
          <div className="rigth-btn">
            <img onClick={this.showVideo} className="play" src={play} alt="" />
            <Icon
              className={['ble-connect-icon', globalStore.btOnConnect ? 'active' : ''].join(' ')}
              icon={globalStore.btOnConnect ? 'icon_lanyakaiqi' : 'icon_status_blue_no'}
            />
          </div>
        </div>
        <div className="process item">
          <div className="process-btn item" onClick={() => this.startDebug()}>
            <div className="process-img">
              <img src={bg} className="process-img-btn" alt="开始安装" />
              <span className={['process-img-btn-desc', status].join(' ')}>{geoBtnDesc}</span>
            </div>
          </div>
          {
            status !== 'default' ? (
              <div>
                <div className="process-progress item">
                  <Progress
                    className="debug-progress"
                    rate={processRate}
                  />
                </div>
                <div className="item">
                  <div className="process-state">
                    {typeof currentProcess === 'function' ? currentProcess() : currentProcess}
                    {
                      status === 'error' ? (
                        <span
                          className="look-detail"
                          onClick={() => this.showLog()}
                        >查看详情
                        </span>
                      ) : ''
                    }
                    {
                       status === 'success' ? (
                         <span
                          className="look-detail"
                          style={{ right: '-80px' }}
                          onClick={() => this.showRadarBase()}
                         >查看雷达基值
                         </span>
                       ) : ''
                    }
                  </div>
                </div>
              </div>
            ) : ''
          }
        </div>
        <UpgradeFrank store={upgradeStore} upGradeType={upGradeType} showUpgrade={showUpgrade} onhideUpgrade={this.hideUpgrade} />
        <AudioInput themeType={themeType} showAudio={showAudio} onhideAudio={this.hideAudio} />
        <Tab data={tabData} className="item" />
        <div>
          <Button type="primary" className="submit-btn" onClick={() => this.onSubmit()}>提交</Button>
        </div>
        <BaseModal
          title="操作日志"
          visible={showLog}
          onCloseModal={() => this.hideLog()}
          showFooter={false}
        >
          <LogDetail store={logStore} />
        </BaseModal>
        <BaseModal
          title="雷达基值"
          visible={showRadarBase}
          onCloseModal={() => this.hideRadarBase()}
          showFooter={false}
        >
          <RadarChart geoStore={this.props.geoStore} />
        </BaseModal>
        <Keyboard
          shwoKeyboard={shwoKeyboard}
          onHideKeyboadr={this.hideKeyboadr}
          onInputParkno={this.inputParkno}
        />
        <Video showVideo={showVideo} onhideVideo={this.hideVideo} />
        {/* <Login type="index" /> */}
        {
          showRepair ? <RepairSerial
          parkinglotname={parkStore.form.parkinglotname}
          parkinglotid={parkStore.form.parkinglotid}
          parkingno={parkStore.form.parkingno}
          oldSerial={oldSerial}
          projectId={projectId}
          onhideRepair={this.hideRepair}
          /> : ''
        }
      </div>
    );
  }
}

export default observer(DebugAuto);
